/*
Safari has a known issue with rendering SVG images when they are resized. 
This can result in SVG images appearing blurry or fuzzy.

A common solution to this problem is to avoid using the <img> tag to display SVGs in Safari. 
Instead, use embed the SVG directly in HTML.
This allows the browser to render the SVG like any other HTML element, 
which often results in a sharper rendering.

From: https://stackoverflow.com/questions/61719982/svg-images-not-rendering-in-safari
*/

export const BlogIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_i_567_826)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.83656 0.583374H10.1641C10.6982 0.583364 11.1441 0.583355 11.5083 0.613114C11.8882 0.644152 12.2449 0.711263 12.5821 0.883107C13.0996 1.14676 13.5203 1.56746 13.7839 2.0849C13.9558 2.42216 14.0229 2.77882 14.0539 3.1587C14.0837 3.52293 14.0837 3.96878 14.0837 4.50292V11.4972C14.0837 12.0313 14.0837 12.4771 14.0539 12.8414C14.0229 13.2213 13.9558 13.5779 13.7839 13.9152C13.5203 14.4326 13.0996 14.8533 12.5821 15.117C12.2449 15.2888 11.8882 15.3559 11.5083 15.387C11.1441 15.4167 10.6983 15.4167 10.1641 15.4167H5.83654C5.30239 15.4167 4.85655 15.4167 4.49232 15.387C4.11244 15.3559 3.75578 15.2888 3.41852 15.117C2.90107 14.8533 2.48038 14.4326 2.21673 13.9152C2.04488 13.5779 1.97777 13.2213 1.94673 12.8414C1.91697 12.4771 1.91698 12.0313 1.91699 11.4971V4.50294C1.91698 3.96879 1.91697 3.52294 1.94673 3.1587C1.97777 2.77882 2.04488 2.42216 2.21673 2.0849C2.48038 1.56746 2.90107 1.14676 3.41852 0.883107C3.75578 0.711263 4.11244 0.644152 4.49232 0.613114C4.85656 0.583355 5.3024 0.583364 5.83656 0.583374ZM4.61447 2.10813C4.32735 2.13159 4.19007 2.17347 4.0995 2.21962C3.8643 2.33946 3.67308 2.53068 3.55323 2.76589C3.50709 2.85645 3.46521 2.99373 3.44175 3.28085C3.41758 3.57673 3.41699 3.96095 3.41699 4.53337V11.4667C3.41699 12.0391 3.41758 12.4234 3.44175 12.7192C3.46521 13.0064 3.50709 13.1436 3.55323 13.2342C3.67308 13.4694 3.8643 13.6606 4.0995 13.7805C4.19007 13.8266 4.32735 13.8685 4.61447 13.8919C4.91035 13.9161 5.29456 13.9167 5.86699 13.9167H10.1337C10.7061 13.9167 11.0903 13.9161 11.3862 13.8919C11.6733 13.8685 11.8106 13.8266 11.9011 13.7805C12.1364 13.6606 12.3276 13.4694 12.4474 13.2342C12.4936 13.1436 12.5354 13.0064 12.5589 12.7192C12.5831 12.4234 12.5837 12.0391 12.5837 11.4667V4.53337C12.5837 3.96095 12.5831 3.57673 12.5589 3.28085C12.5354 2.99373 12.4936 2.85645 12.4474 2.76589C12.3276 2.53068 12.1364 2.33946 11.9011 2.21962C11.8106 2.17347 11.6733 2.13159 11.3862 2.10813C11.0903 2.08396 10.7061 2.08337 10.1337 2.08337H5.86699C5.29456 2.08337 4.91035 2.08396 4.61447 2.10813ZM4.58366 4.66671C4.58366 4.25249 4.91945 3.91671 5.33366 3.91671H10.667C11.0812 3.91671 11.417 4.25249 11.417 4.66671C11.417 5.08092 11.0812 5.41671 10.667 5.41671H5.33366C4.91945 5.41671 4.58366 5.08092 4.58366 4.66671ZM4.58366 7.33337C4.58366 6.91916 4.91945 6.58337 5.33366 6.58337H9.33366C9.74787 6.58337 10.0837 6.91916 10.0837 7.33337C10.0837 7.74759 9.74787 8.08337 9.33366 8.08337H5.33366C4.91945 8.08337 4.58366 7.74759 4.58366 7.33337ZM4.58366 10C4.58366 9.58583 4.91945 9.25004 5.33366 9.25004H6.66699C7.08121 9.25004 7.41699 9.58583 7.41699 10C7.41699 10.4143 7.08121 10.75 6.66699 10.75H5.33366C4.91945 10.75 4.58366 10.4143 4.58366 10Z"
        fill="url(#paint0_linear_567_826)"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_567_826"
        x="1.91699"
        y="0.583374"
        width="12.167"
        height="14.8333"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_567_826" />
      </filter>
      <linearGradient
        id="paint0_linear_567_826"
        x1="14.2231"
        y1="-1.75631"
        x2="3.78669"
        y2="14.9696"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.67" />
      </linearGradient>
    </defs>
  </svg>
);

export const CrossChainIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_i_567_817)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1284 2.31039C12.4339 2.00485 12.9293 2.00485 13.2349 2.31039L15.6894 4.76494C15.9949 5.07048 15.9949 5.56586 15.6894 5.8714L13.2349 8.32595C12.9293 8.63149 12.4339 8.63149 12.1284 8.32595C11.8229 8.02041 11.8229 7.52502 12.1284 7.21948L13.2473 6.10056H11.8692C11.1053 6.10056 10.3918 6.48242 9.96736 7.11821L6.87938 11.7502C6.16458 12.8208 4.96295 13.4642 3.6759 13.4642H2.86344C2.43134 13.4642 2.08105 13.1139 2.08105 12.6818C2.08105 12.2497 2.43134 11.8994 2.86344 11.8994H3.6759C4.43975 11.8994 5.15316 11.5176 5.57764 10.8819L8.66568 6.2498C9.38048 5.17914 10.5821 4.53578 11.8692 4.53578H13.2473L12.1284 3.41685C11.8229 3.11131 11.8229 2.61593 12.1284 2.31039ZM2.08105 5.31817C2.08105 4.88607 2.43134 4.53578 2.86344 4.53578H3.6759C4.96295 4.53578 6.16452 5.17905 6.87932 6.2497C7.11924 6.60907 7.02242 7.0949 6.66304 7.33482C6.30367 7.57475 5.81785 7.47792 5.57793 7.11855C5.15322 6.48241 4.43977 6.10056 3.6759 6.10056H2.86344C2.43134 6.10056 2.08105 5.75027 2.08105 5.31817ZM12.1284 9.67403C12.4339 9.36849 12.9293 9.36849 13.2349 9.67403L15.6894 12.1286C15.9949 12.4341 15.9949 12.9295 15.6894 13.235L13.2349 15.6896C12.9293 15.9951 12.4339 15.9951 12.1284 15.6896C11.8229 15.384 11.8229 14.8887 12.1284 14.5831L13.2477 13.4638H11.8689C10.5881 13.4638 9.38387 12.89 8.66574 11.8144C8.42582 11.455 8.52265 10.9692 8.88202 10.7292C9.24139 10.4893 9.72721 10.5861 9.96714 10.9455C10.3869 11.5742 11.0955 11.899 11.8689 11.899H13.247L12.1284 10.7805C11.8229 10.475 11.8229 9.97957 12.1284 9.67403Z"
        fill="url(#paint0_linear_567_817)"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_567_817"
        x="2.08105"
        y="2.08124"
        width="13.8379"
        height="13.8375"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_567_817" />
      </filter>
      <linearGradient
        id="paint0_linear_567_817"
        x1="16.0771"
        y1="-0.101372"
        x2="7.28542"
        y2="17.0769"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.67" />
      </linearGradient>
    </defs>
  </svg>
);

export const DeveloperApisIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_i_567_852)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5149 2.18412C10.8923 2.26798 11.1303 2.64191 11.0464 3.0193L8.32083 15.2844C8.23697 15.6618 7.86304 15.8998 7.48565 15.8159C7.10825 15.732 6.8703 15.3581 6.95417 14.9807L9.67975 2.7156C9.76362 2.3382 10.1375 2.10025 10.5149 2.18412ZM6.08828 5.09806C6.36165 5.37143 6.36165 5.81464 6.08828 6.08801L3.17628 9.00002L6.08828 11.912C6.36165 12.1854 6.36165 12.6286 6.08828 12.902C5.81492 13.1753 5.3717 13.1753 5.09834 12.902L1.69135 9.49499C1.41799 9.22162 1.41799 8.77841 1.69135 8.50504L5.09834 5.09806C5.3717 4.82469 5.81492 4.82469 6.08828 5.09806ZM11.9123 5.09806C12.1857 4.82469 12.6289 4.82469 12.9022 5.09806L16.3092 8.50504C16.5826 8.77841 16.5826 9.22162 16.3092 9.49499L12.9022 12.902C12.6289 13.1753 12.1857 13.1753 11.9123 12.902C11.6389 12.6286 11.6389 12.1854 11.9123 11.912L14.8243 9.00002L11.9123 6.08801C11.6389 5.81464 11.6389 5.37143 11.9123 5.09806Z"
        fill="url(#paint0_linear_567_852)"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_567_852"
        x="1.48633"
        y="2.1673"
        width="15.0283"
        height="13.6654"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_567_852" />
      </filter>
      <linearGradient
        id="paint0_linear_567_852"
        x1="16.6865"
        y1="0.0118273"
        x2="8.49702"
        y2="17.6088"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.67" />
      </linearGradient>
    </defs>
  </svg>
);

export const CompanyIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_i_1357_4221)">
      <path
        d="M11.814 1.85648C11.7837 1.91714 11.711 1.94305 11.6491 1.91525C10.7284 1.49631 9.60927 1.35476 8.87371 1.35476C6.22913 1.35476 3.58391 2.64445 3.58391 4.76442C3.58391 5.90119 4.43637 6.86292 5.68252 6.86292C7.05947 6.86292 8.08697 5.85759 8.91732 4.93946C9.66045 4.10916 10.535 3.19103 11.7805 3.19103C13.136 3.19103 14.1193 4.19636 14.1193 5.55176C14.1193 7.69385 11.5398 10.0982 7.97702 10.0982C4.41425 10.0982 1.83538 8.1962 1.83538 5.55176C1.83538 3.08171 4.76433 0.852415 7.97765 0.852415C9.61748 0.852415 10.8523 1.19616 11.761 1.68903C11.821 1.72189 11.8444 1.79582 11.814 1.85711V1.85648ZM7.97765 0C3.58391 0 -0.000976562 3.58469 -0.000976562 7.9782C-0.000976562 12.3717 3.58391 16 7.97765 16C12.3714 16 15.9999 12.4153 15.9999 7.9782C15.9999 3.54109 12.4144 0 7.97765 0Z"
        fill="url(#paint0_linear_1357_4221)"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_1357_4221"
        x="-0.000976562"
        y="0"
        width="16.001"
        height="16"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_1357_4221" />
      </filter>
      <linearGradient
        id="paint0_linear_1357_4221"
        x1="16.1833"
        y1="-2.5237"
        x2="6.01791"
        y2="17.3396"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.67" />
      </linearGradient>
    </defs>
  </svg>
);

export const LimitOrderIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_i_567_810)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 3.09375C5.73807 3.09375 3.09375 5.73807 3.09375 9C3.09375 12.2619 5.73807 14.9062 9 14.9062C9.25791 14.9062 9.51156 14.8898 9.76004 14.8579C10.2222 14.7986 10.645 15.1252 10.7043 15.5874C10.7636 16.0496 10.437 16.4724 9.97476 16.5317C9.65526 16.5727 9.32989 16.5938 9 16.5938C4.80609 16.5938 1.40625 13.1939 1.40625 9C1.40625 4.80609 4.80609 1.40625 9 1.40625C13.1939 1.40625 16.5938 4.80609 16.5938 9C16.5938 9.32465 16.5733 9.64492 16.5336 9.95954C16.4753 10.4219 16.0532 10.7493 15.5908 10.691C15.1285 10.6326 14.801 10.2105 14.8594 9.7482C14.8903 9.50351 14.9062 9.25382 14.9062 9C14.9062 5.73807 12.2619 3.09375 9 3.09375ZM9 4.10625C9.46599 4.10625 9.84375 4.48401 9.84375 4.95V8.47853L11.9007 9.50703C12.3175 9.71543 12.4865 10.2222 12.2781 10.639C12.0697 11.0558 11.5629 11.2248 11.1461 11.0164L8.62266 9.75467C8.33681 9.61175 8.15625 9.31959 8.15625 9V4.95C8.15625 4.48401 8.53401 4.10625 9 4.10625ZM13.725 10.8563C14.191 10.8563 14.5688 11.234 14.5688 11.7V12.8813H15.75C16.216 12.8813 16.5938 13.259 16.5938 13.725C16.5938 14.191 16.216 14.5688 15.75 14.5688H14.5688V15.75C14.5688 16.216 14.191 16.5938 13.725 16.5938C13.259 16.5938 12.8813 16.216 12.8813 15.75V14.5688H11.7C11.234 14.5688 10.8563 14.191 10.8563 13.725C10.8563 13.259 11.234 12.8813 11.7 12.8813H12.8813V11.7C12.8813 11.234 13.259 10.8563 13.725 10.8563Z"
        fill="url(#paint0_linear_567_810)"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_567_810"
        x="1.40625"
        y="1.40625"
        width="15.1875"
        height="15.1875"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_567_810" />
      </filter>
      <linearGradient
        id="paint0_linear_567_810"
        x1="16.7678"
        y1="-0.989298"
        x2="7.11836"
        y2="17.8649"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.67" />
      </linearGradient>
    </defs>
  </svg>
);

export const LiquiditySourcesIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_i_567_803)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.0004 2.77295C5.56134 2.77295 2.77344 5.56086 2.77344 8.99991C2.77344 12.439 5.56134 15.2269 9.0004 15.2269C12.4395 15.2269 15.2274 12.439 15.2274 8.99991C15.2274 5.56086 12.4395 2.77295 9.0004 2.77295ZM1.08594 8.99991C1.08594 4.62888 4.62936 1.08545 9.0004 1.08545C13.3714 1.08545 16.9149 4.62888 16.9149 8.99991C16.9149 13.371 13.3714 16.9144 9.0004 16.9144C4.62936 16.9144 1.08594 13.371 1.08594 8.99991ZM4.16135 6.98915C4.49086 6.65965 5.02509 6.65965 5.35459 6.98915L7.58626 9.22081L9.41794 7.38913C9.42197 7.3851 9.42609 7.38098 9.4303 7.37677C9.48887 7.31813 9.56383 7.2431 9.63611 7.18174C9.72111 7.10958 9.85608 7.0083 10.0446 6.94706C10.285 6.86893 10.5441 6.86893 10.7845 6.94706C10.973 7.0083 11.108 7.10958 11.193 7.18174C11.2653 7.2431 11.3402 7.31812 11.3988 7.37675C11.403 7.38097 11.4071 7.3851 11.4111 7.38913L13.8395 9.81744C14.169 10.1469 14.169 10.6812 13.8395 11.0107C13.5099 11.3402 12.9757 11.3402 12.6462 11.0107L10.4145 8.77901L8.58286 10.6107C8.57883 10.6147 8.57471 10.6189 8.57051 10.6231C8.51193 10.6817 8.43698 10.7567 8.3647 10.8181C8.2797 10.8902 8.14472 10.9915 7.95624 11.0528C7.71577 11.1309 7.45674 11.1309 7.21628 11.0528C7.02779 10.9915 6.89282 10.8902 6.80782 10.8181C6.73554 10.7567 6.66059 10.6817 6.60201 10.6231C6.59781 10.6189 6.59369 10.6147 6.58966 10.6107L4.16135 8.18239C3.83185 7.85289 3.83185 7.31865 4.16135 6.98915Z"
        fill="url(#paint0_linear_567_803)"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_567_803"
        x="1.08594"
        y="1.08545"
        width="15.8291"
        height="15.8289"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_567_803" />
      </filter>
      <linearGradient
        id="paint0_linear_567_803"
        x1="17.0963"
        y1="-1.41127"
        x2="7.0393"
        y2="18.2392"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.67" />
      </linearGradient>
    </defs>
  </svg>
);

export const SwapTokenIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_i_567_787)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.8189 2.37647C5.10447 2.0909 5.56747 2.0909 5.85304 2.37647L7.07434 3.59778C7.35992 3.88335 7.35992 4.34635 7.07434 4.63192L5.85304 5.85322C5.56747 6.13879 5.10447 6.13879 4.8189 5.85322C4.5784 5.61272 4.54044 5.24638 4.70502 4.96616C4.07212 5.21732 3.62461 5.83513 3.62461 6.55746C3.62461 6.96131 3.29722 7.28871 2.89336 7.28871C2.4895 7.28871 2.16211 6.96131 2.16211 6.55746C2.16211 4.97619 3.31849 3.66501 4.83172 3.42343L4.8189 3.41061C4.53333 3.12504 4.53333 2.66204 4.8189 2.37647ZM7.18584 5.45921C7.67371 3.5637 9.39352 2.16229 11.4425 2.16229C13.8699 2.16229 15.8377 4.13007 15.8377 6.55746C15.8377 8.60641 14.4363 10.3262 12.5408 10.8141C12.1497 10.9148 11.751 10.6793 11.6503 10.2882C11.5497 9.8971 11.7851 9.49843 12.1762 9.39776C13.4412 9.07216 14.3752 7.92295 14.3752 6.55746C14.3752 4.93779 13.0622 3.62479 11.4425 3.62479C10.077 3.62479 8.92777 4.55871 8.60218 5.82375C8.50151 6.21486 8.10285 6.45031 7.71174 6.34965C7.32062 6.24898 7.08517 5.85032 7.18584 5.45921ZM6.55727 8.51001C4.93761 8.51001 3.62461 9.82301 3.62461 11.4427C3.62461 13.0623 4.93761 14.3753 6.55727 14.3753C8.17694 14.3753 9.48994 13.0623 9.48994 11.4427C9.48994 9.82301 8.17694 8.51001 6.55727 8.51001ZM2.16211 11.4427C2.16211 9.01529 4.12989 7.04751 6.55727 7.04751C8.98465 7.04751 10.9524 9.01529 10.9524 11.4427C10.9524 13.8701 8.98466 15.8378 6.55727 15.8378C4.12989 15.8378 2.16211 13.8701 2.16211 11.4427ZM15.1064 10.7114C15.5103 10.7114 15.8377 11.0388 15.8377 11.4427C15.8377 13.0239 14.6813 14.3351 13.168 14.5767L13.1809 14.5895C13.4664 14.8751 13.4664 15.3381 13.1809 15.6237C12.8953 15.9092 12.4323 15.9092 12.1467 15.6237L10.9254 14.4024C10.7883 14.2652 10.7112 14.0792 10.7112 13.8853C10.7112 13.6913 10.7883 13.5053 10.9254 13.3682L12.1467 12.1469C12.4323 11.8613 12.8953 11.8613 13.1809 12.1469C13.4214 12.3874 13.4593 12.7537 13.2947 13.034C13.9276 12.7828 14.3752 12.165 14.3752 11.4427C14.3752 11.0388 14.7025 10.7114 15.1064 10.7114Z"
        fill="url(#paint0_linear_567_787)"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_567_787"
        x="2.16211"
        y="2.16229"
        width="13.6758"
        height="13.6755"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_567_787" />
      </filter>
      <linearGradient
        id="paint0_linear_567_787"
        x1="15.9944"
        y1="0.00522787"
        x2="7.30557"
        y2="16.9825"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.67" />
      </linearGradient>
    </defs>
  </svg>
);

export const MatchaAutoIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
    <g clipPath="url(#clip0_893_1966)">
      <g filter="url(#filter0_i_893_1966)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.62548 0.966558C9.92112 0.967776 10.1751 1.17685 10.2331 1.46675C10.5143 2.87291 11.3656 4.23945 12.5005 5.14735C13.8563 6.23196 14.6002 7.57953 14.6007 9.05399V9.05544L14.6007 9.05287L14.6007 9.05399C14.6045 10.0369 14.3166 10.9989 13.7732 11.818C13.2297 12.6375 12.4551 13.2771 11.5476 13.6558C10.6401 14.0344 9.64063 14.1352 8.67585 13.9451C7.71106 13.7551 6.82442 13.2829 6.12832 12.5884C5.88506 12.3456 5.88461 11.9517 6.12733 11.7084C6.37005 11.4651 6.76402 11.4647 7.00729 11.7074C7.52892 12.2279 8.19335 12.5817 8.91634 12.7241C9.63932 12.8665 10.3883 12.7911 11.0684 12.5073C11.7484 12.2235 12.3289 11.7442 12.7362 11.1301C13.1435 10.5161 13.3593 9.79488 13.3563 9.05801L13.3563 9.05544C13.3563 8.04158 12.8558 7.02524 11.7231 6.11909C10.8533 5.42327 10.1233 4.50591 9.62202 3.48683C9.51088 3.71242 9.3882 3.93258 9.25435 4.14644C9.07204 4.43773 8.6881 4.52608 8.39681 4.34377C8.10551 4.16145 8.01717 3.77752 8.19948 3.48622C8.58841 2.86481 8.86412 2.17937 9.0138 1.46172C9.07417 1.17232 9.32984 0.96534 9.62548 0.966558ZM5.26736 2.38522C5.56396 2.38522 5.81933 2.59457 5.8775 2.88541C6.02829 3.63936 6.48267 4.37302 7.08557 4.86486C7.90603 5.53418 8.37847 6.3836 8.37847 7.33189C8.37847 9.0488 6.9879 10.4741 5.26736 10.4741C3.54682 10.4741 2.15625 9.0488 2.15625 7.33189C2.15625 6.39479 2.61803 5.52972 3.45377 4.86112C4.05556 4.37969 4.50563 3.64339 4.65722 2.88541C4.71539 2.59457 4.97076 2.38522 5.26736 2.38522ZM5.26929 4.65337C4.99023 5.10398 4.63727 5.50799 4.23117 5.83287C3.63581 6.30916 3.40069 6.83787 3.40069 7.33189C3.40069 8.37764 4.25012 9.22966 5.26736 9.22966C6.2846 9.22966 7.13403 8.37764 7.13403 7.33189C7.13403 6.83661 6.89714 6.31715 6.29893 5.82914C5.89983 5.50356 5.54859 5.10182 5.26929 4.65337Z"
          fill="url(#paint0_linear_893_1966)"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_i_893_1966"
        x="2.15625"
        y="0.966553"
        width="12.4443"
        height="13.0723"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-0.622222" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_893_1966" />
      </filter>
      <linearGradient
        id="paint0_linear_893_1966"
        x1="14.7434"
        y1="-1.09534"
        x2="6.20231"
        y2="14.7918"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.67" />
      </linearGradient>
      <clipPath id="clip0_893_1966">
        <rect
          width="14.9333"
          height="14.9333"
          fill="white"
          transform="translate(0.911133 0.0334473)"
        />
      </clipPath>
    </defs>
  </svg>
);
